import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import CTASection from './components/CTASection';
import ArticleHub from './components/ArticleHub';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <FeatureSection />
      <CTASection />
      <ArticleHub />
      <TestimonialSection />
      <Footer />
    </main>
  );
}